<template>
  <div class="vip">
    <div class="top bgs-[url('@a/assets/images/bg_vip.png')] h-[298px]">
      <div class="pt-2 flex-center-col-x">
        <div class="flex w-[286px]">
          <div class="mt-3 flex">
            <img src="@a/assets/images/vip_tip.png" class="wh-[67px_51px] mx-2" alt="">
            <span class="text-[60px] font-[700] leading-[50px]">{{ level }}</span>
          </div>
          <img src="@a/assets/images/vip_logo.png" class="wh-[91px_57px] ml-auto" alt="">
        </div>

        <div class="mt-4 text-center">
          <p class="text-11 mb-1 w-[282px] truncate">
            {{ formatVipNumber(betAmount) }}/{{ formatVipNumber(nextLevelBet) }}
          <span class="text-white/75 ml-1">  {{ t('Activities.Vip.RechargeToLevelUp', { nextLevelBet: formatVipNumber(nextLevelBet || 0)}) }}</span></p>
          <div class="wh-[281px_3px] bg-white/60 rounded-full overflow-hidden">
            <div class="h-[3px] bg-white w-20" :style="{ width: processWidth }"></div>
          </div>
        </div>

        <div class="mt-10 text-center">
          <h4 class="font-[600]">{{ t('Activities.Vip.CanReceiveBonus') }}</h4>
          <p class="text-30 font-[600] mt-1">{{ isLoggedin ? formatter().format(vipInfo.amount) : formatter().format(100) }}</p>
        </div>

        <img src="@a/assets/images/bn_bonus.png" v-if="isLoggedin && vipInfo.amount > 0" @click="receberBonus" class="size-15 mt-1" />
        <img src="@a/assets/images/bn_bonus2.png" v-else @click="!isLoggedin && showLoginOrReg()" class="size-15 mt-1" />

        <p class="text-11 text-white mt-2" @click="$router.push({path: 'vip/history'})">{{ t('Activities.Vip.BonusHistory') }}></p>
      </div>
    </div>

    <div class="overflow-x-auto">
      <DataTable class="mt-4 !w-[412px]" :columns :data="detailList" round="cell" />
    </div>
    <ActivityDesc class="my-4" :title="t('Activities.Vip.ActivityDescription')" :list="descList" />
  </div>
</template>

<script setup lang="tsx">
import DataTable from '@a/components/DataTable/index.vue'
import ActivityDesc from '@a/components/ActivityDesc/index.vue'
import { getVipInfo, getVipInfoWithoutAuth } from '@/api'
import { useActivityList } from '@/store';
import { ACTIVITY_TYPES } from '@/consts';
import { useUserInfo } from '@/store';
import { formatter } from '@/utils';
import { receber } from '@/hooks/useActivity';
import showLoginOrReg from '@a/components/showLoginOrRegPopup'

import level1 from '@a/assets/images/level1.png';
import level2 from '@a/assets/images/level2.png';
import level3 from '@a/assets/images/level3.png';
import level4 from '@a/assets/images/level4.png';
import level5 from '@a/assets/images/level5.png';
import level6 from '@a/assets/images/level6.png';
import level7 from '@a/assets/images/level7.png';
import level8 from '@a/assets/images/level8.png';
import level9 from '@a/assets/images/level9.png';
import level10 from '@a/assets/images/level10.png';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const vipIcon = [ level1, level2, level3, level4, level5, level6, level7, level8, level9, level10 ];

const vipInfo = ref<any>({
  level: 0,
  amount: 0,
  betAmount: 0,
  detailList: [],
  recordIds: []
});

const systemList = useActivityList().systemList;
const detail = computed(() => systemList.find(item => item.activityType === ACTIVITY_TYPES.VipReward));
const descList = computed(() => detail.value?.activityConfigDesc?.split('\n').map(s => s.trim()) || [])
const isLoggedin = computed(() => useUserInfo().isLoggedin);

const queryVipInfo = async () => {
  showLoadingToast(t('Common.Loading'));
  const fn = isLoggedin.value ? getVipInfo : getVipInfoWithoutAuth;
  const res = await fn();
  vipInfo.value = res.data;
  closeToast();
}

onMounted(() => {
  queryVipInfo()
});

const columns = [
  {
    title: t('Activities.Vip.VipLevel'),
    colClass: '!flex-[1.2]',
    key: 'k1',
    render: (row) => {
      const i = row.level - 1;
      return <div class="flex-end-center gap-1 w-full px-2 h-5">
        { i % 5 === 0 ? <img src={i < 50 ? vipIcon[i / 5] : vipIcon[9]} class="wh-[32px_26px]" /> : null }
        <span>vip{row.level}</span>
      </div>
    }
  },
  {
    title: t('Activities.Vip.AccumulatedBets'),
    colClass: '!flex-[1.2]',
    headClass: '!text-11',
    key: 'k2',
    render: (row) => {
      return <span>{formatVipNumber(row.requireBet, 0)}</span>
    }
  },
  {
    title: t('Activities.Vip.AccumulatedDeposit'),
    colClass: '!flex-[1.2]',
    headClass: '!text-11',
    key: 'k6',
    render: (row) => {
      return <span>{formatVipNumber(row.requireDeposit, 0)}</span>
    }
  },
  {
    title: t('Activities.Vip.UpgradePrize'),
    headClass: '!text-11',
    key: 'k3',
    render: (row) => {
      return <span>{formatVipNumber(row.upgradeRewards, 0)}</span>
    }
  },
  {
    title: t('Activities.Vip.WeeklyBonus'),
    headClass: '!text-11',
    key: 'k4',
    render: (row) => {
      return <span>{formatVipNumber(row.weeklyRewards, 0)}</span>
    }
  },
  {
    title: t('Activities.Vip.MonthlyBonus'),
    headClass: '!text-11',
    key: 'k5',
    render: (row) => {
      return <span>{formatVipNumber(row.monthlyRewards, 0)}</span>
    }
  }
];

const route = useRoute();

const receberBonus = async () => {
  await receber({
    flowType: 'VipReward',
    activityId: route.query.activityId as string,
  })

  queryVipInfo()
}

const detailList = computed(() => vipInfo.value.detailList || []);
const topVipConfig = computed(() => detailList.value?.at(-1) || {});
const nextLevelBet = computed(() => {
  if (isLoggedin.value) {
    const level = Math.min(vipInfo.value.level + 1, topVipConfig.value.level);
    return vipInfo.value.detailList?.find(item => item.level === level)?.requireBet || 0;
  }
  return topVipConfig.value.requireBet || 0;
});
const betAmount = computed(() => isLoggedin.value ? vipInfo.value.betAmount : topVipConfig.value.requireBet);
const level = computed(() => isLoggedin.value ? vipInfo.value.level : topVipConfig.value.level);
const processWidth = computed(() => {
  if (isLoggedin.value) {
    return `${((vipInfo.value.betAmount || 0) / nextLevelBet.value) * 100}%`;
  }
  return '100%';
});

const formatVipNumber = (value: number, mindigits = 2, maxDigits = 2) => {
  const number = parseFloat(value as any)

  if (isNaN(number)) {
    return value // 如果不是有效数字，直接返回原值
  }

  if (number >= 1000000) {
    const formattedValue = number / 1000000
    return `${formatter(mindigits, maxDigits).format(formattedValue)}M`
  }

  if (number >= 1000) {
    const formattedValue = number / 1000
    return `${formatter(mindigits, maxDigits).format(formattedValue)}K`
  }

  return formatter().format(value)
}

</script>

<style lang="scss">
.vip {
  --dataTable-line-height: 33px;

  @apply my-2 text-13;

  .topBanner {
    @apply bgs-[url('@a/assets/images/bg_vip.png')] w-[343px] h-[297px] mx-auto mt-6 relative text-center;

    .label {
      @apply text-12 text-[var(--theme-text-dark)] font-[600] absolute-lt-[14px_0] wh-[68px_30px] leading-30;
    }

    .redPoint {
      @apply text-11 text-white bg-[var(--theme-red)] absolute-rt-[-18px_-5px] size-3.5 rounded-full;
    }
  }

  :deep(.dataTable .tHeader.cell) {
    // @apply text-11;
    font-size: 11px !important;
  }

}
</style>
